export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '国产自拍视频精选合集是什么？',
    answer: '国产自拍视频精选合集是一个专注于本土原创视频内容的聚合平台。我们精心筛选和推荐来自全国各地的优质自拍视频作品，涵盖生活记录、旅行vlog、美食探店、创意短片、数码科技、萌宠日常、时尚美妆、运动健身等多元题材。平台致力于为观众发现真实、有趣、有温度的本土原创视频内容，同时也为创作者提供展示才华的窗口。',
  },
  {
    question: '如何找到自己感兴趣的视频内容？',
    answer: '您可以通过网站首页的分类导航快速找到感兴趣的内容类型。我们目前提供八大内容分类，包括生活记录、旅行Vlog、美食探店、创意短片、数码科技、萌宠日常、时尚美妆和运动健身。每个分类页面都汇集了该领域最受欢迎的精选视频，支持按热度、时间等多种方式浏览。此外，网站首页的精选推荐区域也会根据内容质量和用户喜好推送优质视频。',
  },
  {
    question: '视频内容更新频率如何？',
    answer: '我们保持每日更新，每天都会新增优质国产自拍视频内容。编辑团队会对所有内容进行人工审核和质量把控，确保推荐的每一个视频都符合平台的内容标准——真实、原创、有趣、有价值。关注首页的"最新推荐"区域可以第一时间看到新上线的视频作品。',
  },
  {
    question: '如何成为平台的创作者？',
    answer: '我们欢迎所有热爱视频创作的国产原创作者加入！您可以通过关于我们页面的联系方式与我们取得联系，提交您的作品链接和创作介绍。我们的编辑团队会对作品进行审核，符合平台内容标准和质量要求的创作者将获得推荐机会，您的作品将被展示给更多观众。',
  },
  {
    question: '国产自拍视频和普通短视频有什么区别？',
    answer: '国产自拍视频强调的是"自拍"这一独特的创作视角——创作者既是导演也是主角，用第一人称的镜头语言记录和分享自己的生活。相比普通短视频，国产自拍视频更加真实、接地气，能够带给观众更强的代入感和共鸣。在这里，你可以看到普通人的真实生活、旅行见闻、美食体验和创意表达，每一部作品都有独特的个人风格和温度。',
  },
  {
    question: '平台支持哪些设备观看？',
    answer: '我们的网站采用响应式设计，完美适配电脑、平板和手机等各种设备。无论是在家中使用大屏电脑，还是通勤路上用手机观看，都能获得流畅舒适的浏览体验。网站界面简洁直观，加载速度快，让您随时随地都能找到想看的内容。',
  },
  {
    question: '视频内容是否免费观看？',
    answer: '平台上的所有精选视频内容均为免费浏览，无需注册或付费。我们致力于打造一个开放、共享的本土原创视频内容社区，让更多人能够轻松发现和欣赏优质的国产自拍视频作品。未来我们可能会推出更多增值服务，但核心的视频浏览功能将始终保持免费。',
  },
  {
    question: '如何联系平台或提供反馈建议？',
    answer: '您可以通过关于我们页面提供的联系方式与我们取得联系。我们非常重视每一位用户的反馈和建议，无论是内容推荐、功能改进还是其他问题，都欢迎随时告诉我们。您也可以直接在联系表单中提交您的意见，我们的团队会尽快回复。',
  },
];